export default "__VITE_ASSET__c69ff867__"